<form [formGroup]="shareForm" (ngSubmit)="add()">
    <div class="modal-dialog modal-dialog-centered detail-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Share With</h4>
                <button type="button" class="btn-close" aria-label="Close"
                    (click)="activeModal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-body">
                        <div class="col-md-12">
                            <div class="mb-2">
                                <label for="email" class="form-label">Emails
                                    <span class="mandatory">*</span>
                                </label>
                                <input type="text" class="form-control form-control-sm" id="email"
                                    formControlName="txtEmailIds"
                                    placeholder="Enter multiple emails separated by commas" [ngClass]="{
                                           'is-invalid': (isFormSubmitted || shareForm.get('txtEmailIds').touched) && 
                                           shareForm.get('txtEmailIds').errors
                                       }">
                                <div *ngIf="(isFormSubmitted || shareForm.get('txtEmailIds').touched) && shareForm.get('txtEmailIds').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="shareForm.get('txtEmailIds').errors.required">Email is required.</span>
                                    <span *ngIf="shareForm.get('txtEmailIds').errors.invalidEmails">Invalid email(s)
                                        found. Ensure all emails are correctly formatted.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" data-dismiss="modal">Save</button>
            </div>
        </div>
    </div>
</form>